import * as Init from './init.js';

import * as minute from './workers/minute.js';

import * as market from './workers/market.js';

import * as signal from './workers/signal.js';
import * as spool3 from './workers/spool3.js';

import * as minu_s from './workers/minute.js';

import * as kbar from './workers/kbar.js';
// import * as kbar_b from './workers/kbar_b.js';
import * as kbar_e from './workers/kbar_e.js';

import * as changehold from './workers/changehold.js';

import * as show_shape from './workers/show_shape.js';

import * as foption from './workers/foption.js';
import * as fverify from './workers/fverify.js';
import * as shapeverify from './workers/shapeverify.js';

import * as fcorrel from './workers/fcorrel.js';

import * as adjust from './workers/adjust.js';
import * as adjust_phone from './workers/adjust_phone.js';

function registerMenu(mname, method, argvs) {
    const item = document.getElementById(mname)
    // console.log(item);
    if (item) {
        document.getElementById(mname).addEventListener('click', function () {
            Init.systemInfo.userInfo.rootChart = this.id
            // console.log(Init.systemInfo.userInfo.rootChart);
            Init.changeChart(mname);
            document.activeElement.blur()
        });
        Init.systemInfo.methods[mname] = {
            "method" : method,
            "argvs" : argvs,
        }
    }
}

function registerMethod(mname, method, argvs) {
    // 不在菜单中的功能
    Init.systemInfo.methods[mname] = {
            "method" : method,
            "argvs"  : argvs,
    }
}
// 这里做按钮和图形的对应关系
export function setBtnEvent(systemInfo) {

    // 这里做函数映射
    // mname 不能一样或重复 可以对应同一个方法 通过传递参数来实现不同功能
    registerMenu('btMinute', minute.onLoad)
    registerMenu('btMarket',    market.onLoad, {modulename : "market"})
    registerMenu('btMarket_ZX', market.onLoad, {modulepath : "web/" + Init.systemInfo.username + "/zxcode", modulename : "zxcode"})
    registerMenu('btMarket_DX', market.onLoad, {modulepath : "web/" + Init.systemInfo.username + "/dxcode", modulename : "dxcode"})
    registerMenu('btMarket_CX', market.onLoad, {modulepath : "web/" + Init.systemInfo.username + "/cxcode", modulename : "cxcode"})
    
    registerMenu('btMarket_Admix', market.onLoad, {modulepath : "realtime/admix500F", modulename : "adjust"})
    
    registerMenu('btMarket_QD', market.onLoad, {modulepath : "factors/ftrend", modulename : "trend1"})
    registerMenu('btMarket_NL', market.onLoad, {modulepath : "factors/ftrend", modulename : "trend2"})
    // registerMenu('btMarket_XH', market.onLoad, {modulepath : "factors/feasy",  modulename : "feasy"})

    registerMenu('btSignal', signal.onLoad)
    registerMethod('miSignal_minu', minu_s.onLoad)
    registerMethod('miSignal_kbar', kbar.onLoad, {modulename : "DXQL"})

    registerMenu('btSPool3', spool3.onLoad)
    registerMethod('miSPool3_kbar', kbar.onLoad, {modulename : "SHCC"})

    registerMenu('btKbar', kbar.onLoad, {modulename : "kbar"})
    // registerMenu('btKbar_B', kbar_b.onLoad)
    registerMenu('btKbar_E', kbar_e.onLoad)
    
    registerMenu('btChangeHold_V9', changehold.onLoad, {modulepath : "factors", modulename : "widx9"})
    registerMenu('btChangeHold_V7', changehold.onLoad, {modulepath : "factors", modulename : "wi_vf9"})
    
    registerMenu('btAdjust_Femny', adjust.onLoad, {modulepath : "former/femny", modulename : "femny"})
    registerMenu('btAdjust_Admix', adjust.onLoad, {modulepath : "former/admix", modulename : "admix"})
    
    registerMenu('btAdjust_Shape', adjust.onLoad, {modulepath : "former/shape", modulename : "shape"})
    
    registerMenu('btAdjust_R_Admix_500W', adjust.onLoad, {modulepath : "realtime/admix500F", modulename : "admix500F", mlayout : "realtime"})
    registerMenu('btAdjust_R_Admix_500F', adjust.onLoad, {modulepath : "realtime/admix500L", modulename : "admix500L", mlayout : "realtime"})

    registerMethod('miAdjust_phone', adjust_phone.onLoad, {modulepath : "realtime/", modulename : "adjustphone", moduledata : ["admix500F", "admix500L"]})

    registerMenu('btShape', show_shape.onLoad)

    registerMenu('btFOption', foption.onLoad, {modulepath : "factors", modulename : "option"})
    registerMenu('btFVerify_Normal', fverify.onLoad, {modulepath : "factors", modulename : "verify"})

    registerMenu('btFVerify_Marked', fverify.onLoad, {modulepath : "factors", modulename : "marked"})
    
    registerMenu('btFVerify_Single', fverify.onLoad, {modulepath : "factors", modulename : "single"})
    
    registerMenu('btFVerify_Shape', shapeverify.onLoad, {modulepath : "shape", modulename : "shapeverify"})

    registerMenu('btFCorrel', fcorrel.onLoad, {modulepath : "fcorrel", modulename : "fcorrel"})

    Init.systemInfo.whileCharts = {
        'btKbar': ['btMarket', 'btMinute'],
        'btMarket': ['btMinute', 'btKbar'],
        'btMinute': ['btKbar', 'btMarket'],

        'btMarket_ZX': ['btMinute', 'btKbar'],
        'btMarket_DX': ['btMinute', 'btKbar'],
        'btMarket_CX': ['btMinute', 'btKbar'],

        'btMarket_QD': ['btMinute', 'btKbar'],
        'btMarket_NL': ['btMinute', 'btKbar'],
        'btMarket_Admix': ['btMinute', 'btKbar'],

        'btSignal': ['miSignal_kbar'],
        'btSPool3': ['miSPool3_kbar'],

    }
}